import { MutationTree } from 'vuex';

import { FETCH_FILTER_GROUPS,
  GroupManagementState,
  UPDATE_NAVIGATION,
  REINIT,
  FILTER_GROUP_NAVIGATION,
  USER_SELECTION_REGISTER_GROUP,
  USER_SELECTION_RESET_ACTIONS,
  TRIGGER_GROUP_USER_SELECTION_ACTION,
  USER_SELECTION_CLEAR_GROUPS,
  UPDATE_GROUPS_STATE,
  SET_ERROR,
  IGroupsStatePayload,
  FETCH_TOTAL_GROUPS } from './types';

const mutations: MutationTree<GroupManagementState> = {
  [REINIT](state: GroupManagementState) {
    state.navigation.start = 0;
    state.userSelection.groups = [];
  },
  [FILTER_GROUP_NAVIGATION](state: GroupManagementState, { direction }) {
    const incrementValues: any = {
      forward: state.navigation.groupsPerPage,
      backward: state.navigation.groupsPerPage * -1
    };
    state.navigation.start += incrementValues[direction];
  },
  [USER_SELECTION_REGISTER_GROUP](state: GroupManagementState, groupId: string) {
    const userSelectionDevices = state.userSelection.groups;
    if (!userSelectionDevices.includes(groupId)) {
      state.userSelection.groups.push(groupId);
    } else {
      state.userSelection.groups = userSelectionDevices.filter(e => e !== groupId);
    }
  },
  [USER_SELECTION_RESET_ACTIONS](state: GroupManagementState) {
    Object.keys(state.userSelection.actions).forEach((e) => {
      state.userSelection.actions[e].enabled = false;
    });
  },
  [TRIGGER_GROUP_USER_SELECTION_ACTION](state: GroupManagementState, action: string) {
    if (Object.keys(state.userSelection.actions).includes(action)) {
      state.userSelection.actions[action].enabled = true;
    }
  },
  [USER_SELECTION_CLEAR_GROUPS](state: GroupManagementState) {
    state.userSelection.groups = [];
  },
  [UPDATE_GROUPS_STATE](
    state: GroupManagementState,
    stateToUpdate: IGroupsStatePayload
  ) {
    const {
      view,
      stateKey,
      stateValue
    } = stateToUpdate;

    state.groupsComponentsState[stateKey][view] = stateValue;
  },
  [FETCH_FILTER_GROUPS](state: GroupManagementState, payload) {
    state.groups = payload.filterGroups;
  },
  [UPDATE_NAVIGATION](state: GroupManagementState, payload) {
    state.navigation = payload;
  },
  [SET_ERROR](state: GroupManagementState, payload) {
    state.errorMessage = payload;
  },
  [FETCH_TOTAL_GROUPS](state: GroupManagementState, payload) {
    state.total = payload;
  }
};

export default mutations;
